import { ArrowCta } from '@mc/certificates-design-system'
import { Button, ButtonKindValue } from '@mc/design-system'
import Link from 'components/Link'
import { TrackClick } from 'pages/certificates/tracking'

interface BaseCTAProps {
  text: string
  state?: string
  style?: ButtonKindValue
}

interface PurchaseCertificateCTAProps extends BaseCTAProps {
  href: string
  onClick?: () => void
  className?: string
}

interface DownloadSyllabusCTAProps extends BaseCTAProps {
  onClick: () => void
}

interface StartTrialCTAProps extends BaseCTAProps {
  onClick: () => void
}

export const PurchaseCertificateCTA = ({
  text,
  href,
  state = 'enabled',
  style = 'primary',
  onClick,
  className,
}: PurchaseCertificateCTAProps) => (
  <TrackClick event='purchaseClick'>
    <ArrowCta
      render={<Link href={href} />}
      disabled={state === 'disabled'}
      kind={style}
      className={className}
      onClick={onClick}
    >
      {text}
    </ArrowCta>
  </TrackClick>
)

export const DownloadSyllabusCTA = ({
  text,
  onClick,
  state = 'enabled',
  style = 'secondary',
}: DownloadSyllabusCTAProps) => (
  <TrackClick event='certificateLandingClick' action='download syllabus'>
    <Button onClick={onClick} disabled={state === 'disabled'} kind={style}>
      {text}
    </Button>
  </TrackClick>
)

export const StartTrialCTA = ({
  text,
  onClick,
  state = 'enabled',
}: StartTrialCTAProps) => (
  <TrackClick event='certificateLandingClick'>
    <button
      onClick={onClick}
      disabled={state === 'disabled'}
      className='mc-text--link c-body-bold mc-ml-2'
    >
      {text}
    </button>
  </TrackClick>
)
